import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useInvoicesConversionRateVillagePages from '../useInvoicesConversionRateVillagePages';
import LineChart from '../../../charts/lineChart';
import AlertMessage from '../../../components/alertMessage';
import Helpers from '../../../../../helpers';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    summary,
    loading,
    handleDownloadExcel,
    format,
    title,
    searchParams,
    loadingPdf,
    handleDownloadPdf,
    errors,
  } = useInvoicesConversionRateVillagePages();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('Conversion Rate vs LY').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              loading={loading}
              onClick={handleDownloadExcel}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage errors={errors} searchParams={searchParams} />
        <Spin spinning={loading}>
          <Row className={styles.titleSection} justify={'center'}>
            <Col>
              <Typography.Title level={3}>{title}</Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col xs={24} xxl={12}>
              <Table
                loading={loading}
                columns={columns}
                dataSource={data.tableData}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 500 }}
                summary={summary}
              />
            </Col>
            <Col xs={24} xxl={12}>
              <LineChart
                formatTooltip={(v) => Helpers.changeDotToComa(format(v))}
                data={data.lineChartData}
                tableData={data.tableData}
                colors={['#61cdbb', '#f47560']}
                format={format}
              />
              <br />
              <LineChart
                formatTooltip={(v) => Helpers.changeDotToComa(v)}
                data={data.lineChartData2}
                tableData={data.tableData}
                colors={['#61cdbb', '#f47560']}
                format={format}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default MainPage;
